/**
 *  Where a completed sign-in sends the user, shared by the two routes that finish one:
 *  `redirect-route` (Microsoft Entra ID, arriving with `?token=`) and `auth-callback-route`
 *  (Zitadel, arriving with `?code=`). Both resolve a destination the same way, so the rules
 *  live here rather than in either route.
 */

export const DEFAULT_TARGET = '/projects';

export const isAbsoluteUrl = (value: string) => /^https?:\/\//i.test(value);

/**
 *  Resolves the route to land on after signing in.
 *
 *  Sign-in routes are rejected so a completed sign-in never sends the user back to signing in.
 */
export const sanitizeTarget = (target?: string) => {
  if (!target) {
    return DEFAULT_TARGET;
  }

  const trimmed = target.trim();
  if (!trimmed || trimmed === '/signin' || trimmed === '/redirect') {
    return DEFAULT_TARGET;
  }

  return trimmed;
};
